import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import renderEnvComponent from 'data/common/renderEnvComponent';

class TableCraftsman extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        craftsmen: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        // if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('craftsmanDetails')) {
        return history.push({ pathname: `/${history.environment}/craftsman/detail/${rowData.id}` });
    };

    renderData = memoizeOne(craftsmen => {
        let result = [];

        craftsmen.map((craftsman, craftsmanId) => {
            result.push({
                id: parseInt(craftsmanId),
                label: craftsman.get('label'),
                firstname: craftsman.get('firstname'),
                lastname: craftsman.get('lastname'),
                email: craftsman.get('email'),
                telPort: craftsman.get('telPort'),
                telFixe: craftsman.get('telFixe'),
                isActive: craftsman.get('isActive'),
                craftsmanType: craftsman.get('craftsmanType')
            });
        });

        return result;
    });

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [],
            toolbar: []
        };
        if (profile.get('admin') || userRights.includes('craftsmanDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`)
            });
        }
        return actions;
    });

    renderColumns = memoizeOne(profile => {
        const { history, classes } = this.props;
        return [
            {
                title: Translator.translate('general.table.column.identifier'),
                name: 'id',
                defaultSort: 'asc'
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('craftsmanDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.firstname'),
                name: 'firstname'
            },
            {
                title: Translator.translate('general.table.column.lastname'),
                name: 'lastname'
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.telPort'),
                name: 'telPort'
            },
            {
                title: Translator.translate('general.table.column.telFixe'),
                name: 'telFixe'
            },
            {
                title: Translator.translate('general.table.column.isActive'),
                name: 'isActive',
                render: (row, data, value) => {
                    if (!value) return null;
                    return (
                        <span className={value === Translator.translate('general.craftman-active') ? classes.enabled : classes.disabled}>
                            {value}
                        </span>
                    );
                }
            },
            {
                title: Translator.translate('general.table.column.craftsmanType'),
                name: 'craftsmanType'
            }
        ];
    });

    renderTable() {
        const { craftsmen, profile } = this.props;

        return (
            <FHETable
                idTable="managementDetailCraftsman"
                columns={this.renderColumns(profile)}
                data={this.renderData(craftsmen)}
                actions={this.renderActions(profile)}
                minified
            />
        );
    }

    render() {
        const { craftsmen, theme, history } = this.props;
        return (
            <Fragment>
                {craftsmen.size > 0 ? (
                    this.renderTable()
                ) : (
                    <div style={{ color: theme.palette.text.primary }}>
                        {Translator.translate(`generic.craftsman.table.body.emptyDataSourceMessage`)}
                    </div>
                )}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { managementId, history } = props;
    const craftsmen = state.environments[history.environment].data.Craftsmen.get('list').filter(Craftsman => {
        if (Craftsman.get('managementIds')) {
            return Craftsman.get('managementIds').includes(managementId);
        }
    });

    return {
        profile: state.data.user,
        craftsmen
    };
}

const styles = theme => ({
    enabled: {
        color: theme.palette.success.main
    },
    disabled: {
        color: theme.palette.error.main
    }
});
export default withRouter(
    renderEnvComponent('scenes/Management/Table/TableCraftsman', connect(mapStateToProps)(withStyles(styles, { withTheme: true })(TableCraftsman)))
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Management/Table/TableCraftsman.js